module.exports = __webpack_public_path__ + "5e3e4c78e8dfc3e56494134511b72e27.jpg";


//////////////////
// WEBPACK FOOTER
// ./design/photos/objekte/Ruoff_091122_0127_w.jpg
// module id = 362
// module chunks = 0